<!--
  @author:han.saibo
  @time:2023/12/19
  @disc:操作历史
 -->
 <template>
    <div @keyup.enter="enterSearch">
      <el-form :model="form" label-width="100px" ref="form" class="table-search-bar" inline>
        <el-form-item label="操作人" prop="updatePer">
            <el-input v-model="form.updatePer" placeholder="单行输入"></el-input>
        </el-form-item>
        <el-form-item label="操作时间 " prop="createTime">
            <el-date-picker
            v-model="form.createTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :defaultTime="['00:00:00', '23:59:59']">
            </el-date-picker>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
            <el-button type="primary" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table
        border
        :data="list"
        tooltip-effect="light"
        style="width: 100%">
        <el-table-column
          align="center"
          type="index"
          width="50">
        </el-table-column>
        <el-table-column
          prop="subCustomers"
          label="客户名称"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="categoryQ"
          label="操作前状态"
          :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.categoryQ == 1  ? '已失效' : '生效中'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="categoryH"
          label="操作后状态"
          :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ scope.row.categoryH == 1  ? '已失效' : '生效中'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="updatePer"
          label="操作人"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="updateTime"
          label="操作时间"
          :show-overflow-tooltip="true">
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20 ,50, 100]"
        :page-size="listState.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="listState.total"
        :current-page="listState.pageNo"
        background>
      </el-pagination>
      <el-row class="export-row" type="flex" justify="end">
          <el-col :span="3">
          每页
          <el-select class="width100" v-model="exportForm.pageSize" @change="handleExportSizeChange">
            <el-option v-for="item in sizeOptions"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          条
        </el-col>
        <el-col :span="3">
          第
          <el-select class="width100" v-model="exportForm.pageNo">
            <el-option v-for="item in pageOptions"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          页
        </el-col>
        <el-col :span="3">
          <el-button type="primary" @click="handleExportCSV">导出为CSV文件</el-button>
        </el-col>
      </el-row>
    </div>
  </template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'operationHistory',
  components: {},
  data () {
    return {
      form: {
        updatePer: '',
        createTime: ''
      },
      exportForm: {
        pageSize: 1000,
        pageNo: 1
      },
      sizeOptions: [
        {
          label: '1000',
          value: 1000
        },
        {
          label: '5000',
          value: 5000
        },
        {
          label: '10000',
          value: 10000
        },
        {
          label: '20000',
          value: 20000
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      list: 'getHistoryRecordListMarketablePolicyActCollect',
      listState: 'getHistoryRecordListStateMarketablePolicyActCollect'
    }),
    pageOptions () {
      const total = this.listState.total
      const size = this.exportForm.pageSize
      let totalPage = Math.floor(total / size)
      if (total % size) {
        totalPage++
      }
      const arr = []
      for (let index = 1; index <= totalPage; index++) {
        arr.push({
          label: index,
          value: index
        })
      }
      return arr
    }
  },
  mounted () {
    this.handleSearch()
  },
  methods: {
    ...mapActions(['getHistoryRecordListMarketablePolicyActCollect', 'exportMarketablePolicyActCollectHistoryRecord']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    handleSizeChange (val) {
      this.getHistoryRecordListMarketablePolicyActCollect({ pageNo: 1, pageSize: val })
    },
    handleCurrentChange (val) {
      this.getHistoryRecordListMarketablePolicyActCollect({ pageNo: val })
    },
    // 导出每页条数变动监听
    handleExportSizeChange (val) {
      this.exportForm.pageNo = 1
    },
    handleSearch () {
      const params = {
        ...this.form,
        pageNo: 1
      }
      this.getHistoryRecordListMarketablePolicyActCollect(params)
    },
    // 导出
    handleExportCSV () {
      if (!Array.isArray(this.list) || this.list.length === 0) {
        this.$message({
          message: '暂无数据',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否确认导出', '导出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.exportMarketablePolicyActCollectHistoryRecord({ ...this.form, ...this.exportForm }).then((res) => {
          function createDownloadFile () {
            let blob = new Blob([res])
            let link = document.createElement('a')
            link.download = '会销操作历史.xls'
            link.style.display = 'none'
            link.target = '_Blank'
            link.href = window.URL.createObjectURL(blob)
            document.body.appendChild(link)
            link.click()
            window.URL.revokeObjectURL(link.href)
          }
          createDownloadFile()
          this.$message.success('导出成功')
        })
      }).catch(() => { })
    },
    handleReset () {
      this.$refs['form'].resetFields()
      this.handleSearch()
    }
  }
}
</script>
  <style lang="scss" scoped>
  .export-row {
    margin-top: 10px;
  }
  .width100 {
    width: 100px;
  }
  .blue{
    color:#008ef3;
  }
  </style>
